/**
 * External Dependencies
 */

//import './components/nav';
//import './components/accordion';
//import './components/hero';

import './components/header'
import './components/carousel';
import './components/site-banners';
import './components/faq-section';
import './components/featured-article';
import './components/all-posts';
import './components/single-post_featured-products';
import './components/explore-products-filters';
import './components/single-product-page';
import './components/socials';
import './components/video-modal';
import Search from './components/search';
Search.init();